import module from 'app/module.js'
import './style.scss'

class AppTableHeadersComponent {
  constructor ($element) {
    this.$element = $element
    this.columns = null
    this.appTable = null
    this.cells = []
  }

  $onChanges (changes) {
    if (changes.columns) {
      this.generateCells()
    }
  }

  generateCells () {
    this.$element.empty()
    this.cells = []
    this.columns.forEach((column) => {
      let scope = {}

      column.getHeader(scope, (clone) => {
        this.cells.push(clone)
        this.$element.append(clone)
      })
    })

    this.$element.css('grid-column-end', this.cells.length)
  }
}

module.component('appTableHeaders', {
  controller: AppTableHeadersComponent,
  bindings: {
    columns: '<',
  },
  require: {
    appTable: '^^appTable',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/table/headers/component.js